import { Injectable } from '@angular/core';
import {
  deleteAllCookie,
  getCookie,
  getEnvironmentStatus,
  getLoggedInUser,
  getMerchantProfile,
} from '../shared/security/cookies';
import { LoggedInUser } from '../shared/types/user';

const API_URL: string = environment.reinsuranceApiUrl;
const TOKEN_KEY: string = environment.tokenKey;
import axios from 'axios';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export abstract class ReinsuranceApiService {
  protected service: any;
  public searchEvent: any;
  public created = new Subject();
  public updated = new Subject();
  public filtered = new Subject();
  public errorCallback = new BehaviorSubject<string>('');
  public searchValueChanged: Subject<string> = new Subject();
  documentUploaded = new Subject();
  loggedInUser: any;

  protected constructor(
    protected http: HttpClient,
    protected notify: ToastrService,
    protected router?: Router,
  ) {
    this.service = null;
    if (getCookie('logged_in_user')) {
      this.loggedInUser = getLoggedInUser();
    }
  }

  public async showError(message: string): Promise<any> {
    this.notify.error(message, 'Error!');
  }

  public async showInfo(message: string): Promise<any> {
    this.notify.warning(message, 'Warning!');
  }

  public async showSuccess(message: string, overrideParams: any = {}): Promise<any> {
    this.notify.success(message, 'Success!', overrideParams);
  }

  public async showWarning(message: string, overrideParams: any = {}): Promise<any> {
    this.notify.warning(message, 'Warning!', overrideParams);
  }

  protected abstract getServiceName(): string;

  public create(params: any, successCallBack?: any, urlParams: any = {}, forceMsg?: any, errorCallback?: any): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .post(this.getBaseUrl() + '/' + this.getServiceUrl(), params, {
        params: this.getParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        next: (result: any) => {
          this.service = null;
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
          if (forceMsg) {
            this.showSuccess('Success.').then();
          }
        },
        error: (error: any) => {
          this.service = null;
          errorCallback(error);
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            return;
          }
        },
        complete: () => {},
      });
  }

  public createFromFormData(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${LOGGED_IN_USER.token}`})

    return this.http
      .post(this.getBaseUrl() + '/' + this.getServiceUrl(), params, {
        params: this.getParams(urlParams),
        headers,
      })
      .subscribe({
        next: (result: any) => {
          this.service = null;
          // this.created.next(result);
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
          if (forceMsg) {
            this.showSuccess('Success.').then();
          }
        },
        error: (error: any) => {
          this.service = null;
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            //this.showError(message).then();
            console.log(message);
            return;
          }
          //this.showError(error.error).then();
          console.log(error.error);
        },
        complete: () => {},
      });
  }

  public get(successCallBack: any, urlParams: any = {}): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .get(this.getBaseUrl() + '/' + this.getServiceUrl(), {
        params: this.getParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        complete: () => {},
        error: (error: any) => {
          this.service = null;
          let errorMessage = error?.error?.message;
          if (errorMessage && errorMessage.includes('File does not exist at path')) {
            return;
          }
          errorMessage = errorMessage ? errorMessage : error.error;
          //this.showError(errorMessage);
          console.log(errorMessage);
        },
        next: (result: any) => {
          this.service = null;
          //console.log(result);
          successCallBack(result);
        },
      });
  }

  public openGet(successCallBack: any, urlParams: any = {}): any {
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
    };
    return this.http
      .get(this.getBaseUrl() + '/' + this.getServiceUrl(), {
        params: this.getOpenParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        complete: () => {},
        error: (error: any) => {
          this.service = null;
          let errorMessage = error?.error?.message;
          if (errorMessage && errorMessage.includes('File does not exist at path')) {
            return;
          }
          errorMessage = errorMessage ? errorMessage : error.error;
          //this.showError(errorMessage);
          console.log(errorMessage);
        },
        next: (result: any) => {
          this.service = null;
          //console.log(result);
          successCallBack(result);
        },
      });
  }

  public getById(id: string, successCallBack: any, urlParams: any = {}): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .get(this.getBaseUrl() + '/' + this.getServiceUrl() + '/' + id, {
        params: this.getParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        complete: () => {
          this.service = null;
        },
        error: (error: any) => {
          console.log('................................................');
          console.log(error);
          this.service = null;
          if (error?.status === 401) {
            this.showInfo('Your session has expired. Please login again.').then();
            setTimeout(() => {
              deleteAllCookie();
              window.location.href = '/sign-in';
            }, 5000);
            return;
          }
          let errorMessage = error?.error?.error;
          if (errorMessage && typeof errorMessage === 'string') {
            //this.showError(errorMessage).then();
            console.log(errorMessage);
            return;
          }
          errorMessage = error?.error?.message;
          if (errorMessage && errorMessage.includes('File does not exist at path')) {
            return;
          }
          errorMessage = errorMessage ? errorMessage : error.error;
          console.log(errorMessage);
          //this.showError(errorMessage).then();
          this.errorCallback.next({
            ...error,
            serviceName: this.getServiceName(),
          });
        },
        next: (result: any) => {
          this.service = null;
          successCallBack(result);
        },
      });
  }

  public activate(id: string, successCallBack?: any, urlParams: any = {}, forceMsg?: any): any {
    this.service = this.getServiceName() + `/activate/${id}`;
    return this.get(successCallBack, urlParams);
  }

  public deactivate(id: string, successCallBack?: any, urlParams: any = {}, forceMsg?: any): any {
    this.service = this.getServiceName() + `/deactivate/${id}`;
    return this.get(successCallBack, urlParams);
  }

  public approve(id: string, successCallBack?: any, urlParams: any = {}, forceMsg?: any): any {
    this.service = this.getServiceName() + `/approve/${id}`;
    return this.get(successCallBack, urlParams);
  }

  public update(packet: any, successCallBack?: any, forceMsg?: any, errorCallback?: any): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .patch(this.getBaseUrl() + '/' + this.getServiceUrl(), packet, {
        params: this.getParams({}),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        complete: () => {},
        error: (error: any) => {
          this.service = null;
          errorCallback(error);
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            return;
          }
        },
        next: (result: any) => {
          this.service = null;
          // this.created.next(result);
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
          if (forceMsg) {
            this.showSuccess('Success.').then();
          }
        },
      });
  }

  public disapprove(id: string, successCallBack?: any, urlParams: any = {}, forceMsg?: any): any {
    this.service = this.getServiceName() + `/disapprove/${id}`;
    return this.get(successCallBack, urlParams);
  }

  public delete(id: string, successCallBack?: any, urlParams: any = {}, forceMsg?: any): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .delete(this.getBaseUrl() + '/' + this.getServiceUrl() + '/' + id, {
        params: this.getParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        complete: () => {},
        error: (error: any) => {
          this.service = null;
          console.log(error);
        },
        next: (result: any) => {
          this.service = null;
          successCallBack(result);
        },
      });
  }

  public setServiceUrl(url: string): any {
    this.service = url;
    return this;
  }

  protected getParams(urlParams: any): any {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      urlParams.access_token = token;
    }
    urlParams.time = new Date().getTime();
    return urlParams;
  }

  protected getOpenParams(urlParams: any): any {
    urlParams.time = new Date().getTime();
    return urlParams;
  }

  private getServiceUrl(): string {
    if (this.service) {
      //console.log('this is a service', this.service);
      return this.service;
    }
    // console.log('this is a service name', this.getServiceName());
    return this.getServiceName();
  }

  private logoutAndRedirect(error: any): any {
    if (error.status === 401) {
      localStorage.clear();
      this.showInfo('For your own security. Please login to continue.').then();
      // @ts-ignore
      this.router.navigate(['/sign-in']);
    }
  }

  public loginWithCredentials(params: any, successCallBack?: any, errorCallBack?: any): any {
    return this.http
      .post(this.getBaseUrl() + '/api/auth/account/authenticate', params, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe({
        next: (result: any) => {
          console.log(result);
          this.service = null;
          this.created.next(result);
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
        },
        error: (error: any) => {
          errorCallBack(error);
          this.service = null;
        },
        complete: () => {},
      });
  }

  protected getBaseUrl(): string {
    return API_URL;
  }

  protected isLiveEnvironment(): boolean {
    return getEnvironmentStatus() === 'live';
  }

  public requestAccountApproval(
    params: any,
    successCallBack?: any,
    urlParams: any = {},
    forceMsg?: any,
    errorCallback?: any,
  ): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .post(this.getBaseUrl() + '/' + this.getServiceUrl() + '/' + LOGGED_IN_USER.accountId, params, {
        params: this.getParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        next: (result: any) => {
          this.service = null;
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
          if (forceMsg) {
            this.showSuccess('Operation completed.').then();
          }
        },
        error: (error: any) => {
          this.service = null;
          errorCallback(error);
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            return;
          }
        },
        complete: () => {},
      });
  }

  public getReportById(id: string, successCallBack: any, urlParams: any = {}): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    axios
      .get(this.getBaseUrl() + '/' + this.getServiceUrl() + '/' + id, {
        headers: { Authorization: `Bearer ${LOGGED_IN_USER.token}` },
      })
      .then((response) => {
        successCallBack(response);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  public getTransactions(successCallBack: any, urlParams: any = {}): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };

    return this.http
      .post(this.getBaseUrl() + '/' + this.getServiceUrl(), this.getParams(urlParams), {
        headers: AUTH_HEADERS,
      })
      .subscribe({
        complete: () => {},
        error: (error: any) => {
          this.service = null;
          let errorMessage = error?.error?.message;
          if (errorMessage && errorMessage.includes('File does not exist at path')) {
            return;
          }
          errorMessage = errorMessage ? errorMessage : error.error;
          //this.showError(errorMessage);
          console.log(errorMessage);
        },
        next: (result: any) => {
          this.service = null;
          console.log(result);
          successCallBack(result);
        },
      });
  }

  public linkOtherBanksToProfile(packet: any, successCallBack: any, forceMsg: any, errorCallback: any) {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .post(this.getBaseUrl() + '/' + this.getServiceUrl(), packet, {
        headers: AUTH_HEADERS,
      })
      .subscribe({
        next: (result: any) => {
          this.service = null;
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
          if (forceMsg) {
            this.showSuccess('Success.').then();
          }
        },
        error: (error: any) => {
          this.service = null;
          errorCallback(error);
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            return;
          }
        },
        complete: () => {},
      });
  }

  public deLinkOtherBanksFromProfile(id: string, successCallBack: any, forceMsg: any, errorCallback: any) {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .delete(this.getBaseUrl() + '/' + this.getServiceUrl() + '/' + id, {
        headers: AUTH_HEADERS,
      })
      .subscribe({
        complete: () => {},
        error: (error: any) => {
          this.service = null;
          errorCallback(error);
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            return;
          }
        },
        next: (result: any) => {
          this.service = null;
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
          if (forceMsg) {
            this.showSuccess('Success.').then();
          }
        },
      });
  }

  public regenerateApiKey(params: any, successCallBack: any, urlParams: any = {}, forceMsg?: any, errorCallback?: any) {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    params = getMerchantProfile();
    console.log(params);
    const AUTH_HEADERS = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .post(this.getBaseUrl() + '/' + this.getServiceUrl(), params, {
        params: this.getParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        next: (result: any) => {
          this.service = null;
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          }
        },
        error: (error: any) => {
          this.service = null;
          errorCallback(error);
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            return;
          }
        },
        complete: () => {},
      });
  }

  public updateFromFormData(params: any, successCallBack?: any, urlParams: any = {}, forceMsg?: any): any {
    const LOGGED_IN_USER: LoggedInUser = getLoggedInUser();
    const AUTH_HEADERS = {
      Authorization: `Bearer ${LOGGED_IN_USER.token}`,
    };
    return this.http
      .patch(this.getBaseUrl() + '/' + this.getServiceUrl(), params, {
        params: this.getParams(urlParams),
        headers: AUTH_HEADERS,
      })
      .subscribe({
        next: (result: any) => {
          this.service = null;
          // this.created.next(result);
          if (typeof successCallBack === 'function') {
            successCallBack(result);
          } else {
            this.showSuccess(result).then();
          }
          if (forceMsg) {
            this.showSuccess('Success.').then();
          }
        },
        error: (error: any) => {
          this.service = null;
          this.logoutAndRedirect(error);
          if (error.error?.message) {
            const message = error.error.message.toLowerCase().includes('server')
              ? 'The data you provided is invalid'
              : error.error.message;
            //this.showError(message).then();
            console.log(message);
            return;
          }
          //this.showError(error.error).then();
          console.log(error.error);
        },
        complete: () => {},
      });
  }
}
